import { Button, Select } from '@mantine/core';
import { Search } from 'lucide-react';
import { FC, useState } from 'react';

import useTaskFormOptions from '@/hooks/useTaskFormOptions.ts';

interface Props {
    onConfirm: (id: string) => Promise<void>;
    onClose: () => void;
    onCancel: () => void;
    instanceId: string;
}

const TaskAssignModal: FC<Props> = ({ onConfirm, onClose, onCancel, instanceId }) => {
    const [assignee_id, setAssigneeId] = useState<string>();
    const [is_loading, setIsLoading] = useState(false);
    const { assignee_options } = useTaskFormOptions(instanceId);

    const handleConfirm = async (): Promise<void> => {
        if (!assignee_id) return;
        setIsLoading(true);
        await onConfirm(assignee_id);
        onClose();
    };

    return (
        <div className="flex flex-col space-y-4">
            <Select
                label="Bearbeiter"
                placeholder="Bearbeiter wählen"
                data={assignee_options}
                searchable
                leftSection={<Search className="size-4" />}
                onChange={(value) => setAssigneeId(value ?? '')}
                value={assignee_id}
            />

            <div className="mt-6 flex gap-2">
                <Button
                    variant="subtle"
                    color="gray"
                    className="w-full"
                    onClick={() => {
                        onCancel();
                        onClose();
                    }}
                >
                    Abbrechen
                </Button>
                <Button
                    variant="filled"
                    className="w-full"
                    onClick={handleConfirm}
                    disabled={!assignee_id}
                    loading={is_loading}
                >
                    Weiter
                </Button>
            </div>
        </div>
    );
};

export default TaskAssignModal;
